






import Vue from 'vue';
import Component from 'vue-class-component';

/**
 * @status stable
 * @published 4.7.0
 * @changelog 4.7.0 Published.
 */
@Component
export default class JdsEcho extends Vue {}
